import request from './interceptor'

export function getStationOrders(params) {
  return request({
    url: '/v1/service-station/orders',
    method: 'get',
    params
  })
}

export function getStationStats(params) {
  return request({
    url: '/v1/service-station/stats',
    method: 'get',
    params
  })
}

export function getStationOrderDetail(id) {
  return request({
    url: `/v1/service-station/orders/${id}`,
    method: 'get'
  })
}

export function transferStationOrder(id, data) {
  return request({
    url: `/v1/service-station/orders/${id}/transfer`,
    method: 'post',
    data
  })
}

export function cancelStationOrder(id, data) {
  return request({
    url: `/v1/service-station/orders/${id}/cancel`,
    method: 'post',
    data
  })
}
